import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { getRequest, postRequest, tabulatorGet } from '../../api/ApiController';
import { PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, PaperClipIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon } from "../svg/svgIcons";
import { InfinitySpin } from 'react-loader-spinner';
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import UtilContext from '../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import "../../assets/css/docviewer.css";
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../utils/maintenanceNavigationContext';
import { useMaintenanceTypes } from '../../utils/useMaintenanceTypes';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { showDeactivatedInLists, showExcludedMachinesInLists } from '../../utils/moduleSettings';
import { cleanSorters, extractSafePaginationParams, createDedupedAjaxRequest, refreshProgressiveFromStart, applyUserMaskRowToTabulator, mergePagedStandardListFiltersAndSorters, appendMaintenanceMachineDetailTypePagedFilter, safeParse } from '../../utils/tabulatorProgressiveLoading';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { getPusherChannel } from '../../utils/pusherChannel';
import { getEffectiveMask } from '../../utils/effectiveMask';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../utils/maintenanceTabulatorMaskActions';
import {
  buildScheduledTreeAuditTabulatorColumns,
  mergeColumnVisibilityWithAuditDefaults,
  scheduleExpandRemoteTreeRowsForActiveAuditFilter,
} from '../../utils/tabulatorAuditColumns';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../utils/printChrome';
import { LocaleContext } from '../../components/LocaleContext';

const MASK_PAGE = 'MaintenanceMachineDetail';

const DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY = Object.freeze({
  id: true,
  'machine.name': true,
  'machine.machine_type.name': true,
  custom_last_execution_date: true,
  custom_next_execution_date: true,
  custom_state: true,
  custom_deactivation_date: true,
  description: true,
  machine_part: true,
  protocol: true,
  scheduled_files: true,
  'company.name': true,
  custom_lecturer_name: true,
  custom_contact_name: true,
  created_at: true,
  updated_at: true,
});

function mergeMaintenanceMachineDetailColumnVisibilityFromSaved(saved) {
  return mergeColumnVisibilityWithAuditDefaults(DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY, saved);
}

function applyMaintenanceMachineDetailDataColumnVisibility(table, visibility) {
  if (!table) return;
  for (const field of Object.keys(DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY)) {
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}

export default function MaintenanceMachineDetail({maintenance_type, type, navigationContext}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,openFilePreview,getDateFormat,getUserColor,getUserInitials, openChosenNotificationPreferences} = useContext(UtilContext);
    const {user} = useContext(AuthContext);
    const { loading: loadingTypes, refetch: refetchMaintenanceTypes } = useMaintenanceTypes();

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const auditTreeExpandInProgressRef = useRef(false);
    const auditTreeExpandScheduleRef = useRef(null);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    /** Aby sme nedávali GET maintenance_types/{id} dvakrát (Strict Mode / double mount). */
    const loadingMaintenanceTypeIdRef = useRef(null);

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const showDeactivated = showDeactivatedInLists(state.module_settings, 'maintenance');
    const showExcludedMachines = showExcludedMachinesInLists(state.module_settings);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const [formMaintenanceType, setFormMaintenanceType] = useState(maintenance_type);
    const currentMaintenanceTypeIdRef = useRef(maintenance_type?.id ?? null);
    const prevMaintenanceTypeIdRef = useRef(maintenance_type?.id);
    const [formType, setFormType] = useState(type);
    /** true počas načítavania plného záznamu pre ľavý panel (GET maintenance_types/{id}), nie tabuľky */
    const [loadingDetailData, setLoadingDetailData] = useState(false);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);
    const scheduleAuditTreeExpand = useCallback(() => {
        if (isRestoringRef.current) return;
        scheduleExpandRemoteTreeRowsForActiveAuditFilter(getTable, auditTreeExpandInProgressRef, auditTreeExpandScheduleRef);
    }, [getTable]);

    useEffect(() => () => {
        if (auditTreeExpandScheduleRef.current != null) {
            clearTimeout(auditTreeExpandScheduleRef.current);
        }
    }, []);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    // Pusher: machine_card – tento detail používa paged cards, row id = card id
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const onCreated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('machine_card.created', id)) return;
        getRequest(`/api/machine_cards/${id}`).then((res) => {
          const rowData = res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
        }).catch(() => {});
      };
      const onUpdated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('machine_card.updated', id)) return;
        getRequest(`/api/machine_cards/${id}`).then((res) => {
          const rowData = res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
        }).catch(() => {});
      };
      const onDeleted = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('machine_card.deleted', id)) return;
        const table = getTable();
        const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
        if (row) row.delete();
      };
      channel.bind('machine_card.created', onCreated);
      channel.bind('machine_card.updated', onUpdated);
      channel.bind('machine_card.deleted', onDeleted);
      return () => {
        channel.unbind('machine_card.created', onCreated);
        channel.unbind('machine_card.updated', onUpdated);
        channel.unbind('machine_card.deleted', onDeleted);
      };
    }, [getTable]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
        if (extra.size == null) extra.size = pageSizePc;
        extra.show_deactivated = showDeactivated ? '1' : '0';
        extra.show_excluded_machines = showExcludedMachines ? '1' : '0';
        const typeId = currentMaintenanceTypeIdRef.current;
        if (typeId != null) extra.filter_maintenance_type_id = String(typeId);
        mergePagedStandardListFiltersAndSorters(extra, {
            getTable,
            tableBuiltForParams: tableBuiltRef.current,
            userMaskFilters: state.user_mask_filters,
            maskPage: MASK_PAGE,
            appendFilter: appendMaintenanceMachineDetailTypePagedFilter,
        });
        return extra;
    }, [getTable, pageSizePc, showDeactivated, showExcludedMachines, state.user_mask_filters]);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
const [companyContactsList, setCompanyContactsList] = useState([]);
    const effectiveCompanyContacts = (state.company_contacts || []).length ? (state.company_contacts || []) : companyContactsList;

    useEffect(() => {
        if ((state.company_contacts || []).length > 0) return;
        getRequest("/api/company_contacts?minimal=1&module=maintenance")
            .then((r) => { const list = r?.data ?? r ?? []; setCompanyContactsList(Array.isArray(list) ? list : []); })
            .catch(() => {});
    }, [state.company_contacts?.length]);

    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit maintenance"))?false:true);

    const [images,setImages] = useState('');

    useEffect(() => {
        // Update the document title using the browser API
        if(formMaintenanceType!=null){
            //getImages();
        }
    }, [formMaintenanceType?.id]);

    const resetDetailUiOnNavigate = useCallback(() => {
        setMaskVisible(false);
        setImages('');
        loadingMaintenanceTypeIdRef.current = null;
    }, []);

    useEffect(() => {
        currentMaintenanceTypeIdRef.current = formMaintenanceType?.id ?? null;
    }, [formMaintenanceType?.id]);

    useEffect(() => {
        const prevId = prevMaintenanceTypeIdRef.current;
        const nextId = formMaintenanceType?.id;
        if (prevId === nextId) return;
        prevMaintenanceTypeIdRef.current = nextId;
        if (nextId == null || !tableBuiltRef.current) return;
        inFlightRef.current = { sig: null, promise: null };
        completedCacheRef.current.clear();
        captureHScroll();
        refreshFromStart();
    }, [formMaintenanceType?.id, captureHScroll, refreshFromStart]);

    function getImages(id=null){
        getRequest(`/api/maintenance_types/protocols/${id ? id : formMaintenanceType.id}`).then((response) => {
            if(response.data!=="{}")setImages(response.data);
        });
    }

    function viewFile(file_id){
        getRequest(`/api/maintenance_scheduled_records/protocol/${file_id}`).then((response) => {
            const d = response.data;
            if (d?.url) openFilePreview({ url: d.url, filename: d.filename || 'súbor' });
        });
    }

    /** Otvorenie predlohy z karty stroja (MaintenanceScheduledFile) */
    function viewFileCard(file_id){
        getRequest(`/api/machine_cards/protocol/${file_id}`).then((response) => {
            const d = response?.data?.data ?? response?.data;
            if (d?.url) openFilePreview({ url: d.url, filename: d.filename || 'súbor' });
        });
    }

    const normalizeText = (value) => (value || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    function textHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = zobraz všetko
        return normalizeText(rowValue).includes(normalizeText(headerValue));
    }

    function MachineNameTreeFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const parent = props.cell.getRow()?.getTreeParent();

        // parent riadok (má _children) → zobraz názov stroja
        if (rowData?._children) {
            return <div className="training_name">{rowData.machine?.name}</div>;
        }

        // child riadok → zobraz "Prvotné / Opakované"
        if (parent) {
            const parentArray = parent._row.data._children || [];
            for (let i = 0; i < parentArray.length; i++) {
            if (parentArray[i].id == rowData.id) {
                if (i === parentArray.length - 1) {
                return <div className="training_name">Prvotné vykonanie</div>;
                }
                return <div className="training_name">{parentArray.length - 1 - i}. Opakované vykonanie</div>;
            }
            }
            return <div className="training_name">{parent._row.data.machine?.name}</div>;
        }

        return <div className="training_name">{rowData.machine?.name}</div>;
    }

    function machineHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || headerValue.trim() === "") return true;
        // filtruj len parent riadky (tie majú _children)
        if (!rowData?._children) return true;

        const normalize = (val) =>
            (val || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

        return normalize(rowData?.machine?.name).includes(normalize(headerValue));
    }

    const LECTURER_EXTERNAL = t('Common.ServiceCompanyEmployee');
    const LECTURER_INTERNAL = t('Common.InternalEmployee');

    function LastExecutionDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].last_execution_date).toFormat(dateFmt);
        if(rowData?.last_execution_date) return DateTime.fromISO(rowData?.last_execution_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('Common.NotPerformed')}</span>;
    }

    function NextExecutionDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].next_execution_date).toFormat(dateFmt);
        if(rowData?.next_execution_date) return DateTime.fromISO(rowData?.next_execution_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('Common.NotPerformed')}</span>;
    }

      function StateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==0){
                        if(parent._row.data?.deactivation_date!=null && parent._row.data?.deactivation_date!=""){
                            return "DEA";
                        }
                        else if(new Date(parent_array[i]?.next_execution_date) < new Date()){
                            return "NOK";
                        }
                        else return "OK";
                    }
                    else return "OK";
                }
            }
        }
        if(rowData?.deactivation_date!=null && rowData?.deactivation_date!="") return "DEA";
        if(rowData?._children?.length > 0){           
            if(new Date(rowData?._children[0]?.next_execution_date) < new Date()){
                return "NOK";
            }
            return "OK"
        }
        else if(new Date(rowData?.initial_date) > new Date()){
          return "OK";
        }
        else return "NOK";
      }

    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if (!headerValue || headerValue.trim() === "") return true;
        const hv = headerValue.trim();
        const n = normalizeText(hv);
        // keď nemá children
        if (!rowData?._children || rowData._children.length === 0) {
        if (new Date(rowData?.initial_date) > new Date()) {
            return normalizeText(t('Common.Scheduled')).includes(n);
        }
        return normalizeText(t('Common.NotPerformed')).includes(n);
        }
        // keď má children – substring v zobrazenom dátume aj v ISO
        const child0 = rowData._children[0];
        if (!child0) return false;
        if (filterParams?.name === "last_execution_date") {
        const iso = child0.last_execution_date ? String(child0.last_execution_date) : "";
        const formatted = child0.last_execution_date ? DateTime.fromISO(child0.last_execution_date).toFormat(dateFmt) : "";
        return normalizeText(formatted).includes(n) || normalizeText(iso).includes(n);
        }
        if (filterParams?.name === "next_execution_date") {
        const iso = child0.next_execution_date ? String(child0.next_execution_date) : "";
        const formatted = child0.next_execution_date ? DateTime.fromISO(child0.next_execution_date).toFormat(dateFmt) : "";
        return normalizeText(formatted).includes(n) || normalizeText(iso).includes(n);
        }
        return true;
    }

    function stateHeaderFilter(headerValue, rowValue, rowData){
        if (!headerValue || String(headerValue).trim() === "") return true;
        let state = "";
        if (rowData?.deactivation_date) state = "DEA";
        else if (rowData?._children?.length > 0) {
            state = new Date(rowData._children[0]?.next_execution_date) < new Date() ? "NOK" : "OK";
        } else if (new Date(rowData?.initial_date) > new Date()) {
            state = "OK";
        } else {
            state = "NOK";
        }
        const selected = new Set(String(headerValue).split(/[\s,;|]+/).map(s => s.trim().toUpperCase()).filter(Boolean));
        return selected.has(state.toUpperCase());
    }
    function stavUkonuHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === "") return true;
        const label = (rowData?.deactivation_date != null && rowData?.deactivation_date !== "") ? t('Status.Deactivated') : "Aktívny";
        const selected = new Set(String(headerValue).split(/[\s,;|]+/).map(s => s.trim()).filter(Boolean));
        return selected.has(label);
    }

    function DeactivationDate(props) {
      const rowData = props.cell.getRow().getData();
      return rowData?.deactivation_date ? DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt) : "";
    }

    function getCompanyContactFromRow(rowData, allContacts = []) {
      if (rowData?.company_contact) return rowData.company_contact;
      const id = rowData?.company_contact_id;
      if (!id) return null;
      return allContacts.find(c => String(c.id) === String(id)) || null;
    }

    function getLecturerLabelFromContact(cc) {
      if (!cc) return "";
      return cc.employee_id != null ? LECTURER_INTERNAL : LECTURER_EXTERNAL;
    }

    function getLecturerLabelFromRow(rowData, allContacts = []) {
      const cc = getCompanyContactFromRow(rowData, allContacts);
      return getLecturerLabelFromContact(cc);
    }

    function getEffectiveServiceCompanyName(cardData, rowData) {
      const mt = cardData?.maintenance_type;
      if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
        return mt?.centralCompany?.name || mt?.central_company?.name || '';
      }
      return rowData?.company?.name || cardData?.company?.name || '';
    }

    function getCentralServiceContactFromCard(cardData) {
      const mt = cardData?.maintenance_type;
      if (!mt?.use_central_service_person || !(mt?.central_company_id || mt?.central_company_contact_id)) return null;
      return mt?.centralCompanyContact || mt?.central_company_contact || null;
    }

    function getEffectiveCompanyContactForRow(rowData, cardData, allContacts) {
      const central = getCentralServiceContactFromCard(cardData);
      if (central) return central;
      return getCompanyContactFromRow(rowData, allContacts) || getCompanyContactFromRow(cardData, allContacts);
    }

    function getEffectiveLecturerLabelForRow(rowData, cardData, allContacts) {
      const cc = getEffectiveCompanyContactForRow(rowData, cardData, allContacts);
      return getLecturerLabelFromContact(cc);
    }

    function getEffectiveContactNameForRow(rowData, cardData, allContacts) {
      const cc = getEffectiveCompanyContactForRow(rowData, cardData, allContacts);
      if (!cc) return '';
      return cc.employee_id != null ? (cc.employee?.name || '') : (cc.name || '');
    }

    function LecturerName(props) {
      const row = props.cell.getRow();
      const rowData = row.getData();
      const parent = row.getTreeParent();
      const cardData = parent ? parent.getData() : rowData;
      return getEffectiveLecturerLabelForRow(rowData, cardData, effectiveCompanyContacts);
    }

    function lecturerHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || headerValue.trim() === "") return true;
      const label = rowData?.maintenance_type
        ? getEffectiveLecturerLabelForRow(rowData, rowData, effectiveCompanyContacts)
        : getLecturerLabelFromRow(rowData, effectiveCompanyContacts);
      if (!label) return false;
      return normalizeText(label).includes(normalizeText(headerValue));
    }

    function ContactFormatter(props) {
      const row = props.cell.getRow();
      const rowData = row.getData();
      const parent = row.getTreeParent();
      const cardData = parent ? parent.getData() : rowData;
      return getEffectiveContactNameForRow(rowData, cardData, effectiveCompanyContacts);
    }

    function contactHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || headerValue.trim() === "") return true;
      const name = rowData?.maintenance_type
        ? getEffectiveContactNameForRow(rowData, rowData, effectiveCompanyContacts)
        : (() => {
            const cc = getCompanyContactFromRow(rowData, effectiveCompanyContacts);
            return (cc?.employee?.name || cc?.name || '');
          })();
      return normalizeText(name).includes(normalizeText(headerValue));
    }

    function serviceCompanyHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue) return true;
      const name = rowData?.maintenance_type
        ? getEffectiveServiceCompanyName(rowData, rowData)
        : (rowData?.company?.name || '');
      return normalizeText(name).includes(normalizeText(headerValue));
    }

    // Protokol = len MaintenanceScheduledRecordFile (súbory záznamu). Pri karte nikdy nepoužívať rowData.files – to sú predlohy (MaintenanceScheduledFile).
    function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        const isCardRow = rowData?._children !== undefined && Array.isArray(rowData._children);
        const recordFiles = isCardRow ? (rowData._children[0]?.files || []) : (rowData.files || []);
        const hasFiles = Array.isArray(recordFiles) && recordFiles.length > 0;
        if (!hasFiles) return null;
        return (
            <div className='flex flex-row'>
                {recordFiles.map((img) => (
                    <a key={img.id} style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px', width: '24px', display: 'block' }} onClick={() => { viewFile(img.id); }} title={img.filename}><PaperClipIcon /></a>
                ))}
            </div>
        );
    }

    function Predloha(props) {
        const row = props.cell.getRow();
        const rowData = row.getData();
        const parent = row.getTreeParent();
        const cardFiles = parent ? (parent.getData()?.files || []) : (rowData?.files || []);
        const hasFiles = Array.isArray(cardFiles) && cardFiles.length > 0;
        if (!hasFiles) return null;
        return (
            <div className='flex flex-row'>
                {cardFiles.map((img) => (
                    <a key={img.id} style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px', width: '24px', display: 'block' }} onClick={() => { viewFileCard(img.id); }} title={img.filename}><PaperClipIcon /></a>
                ))}
            </div>
        );
    }

    function ServisnaFirmaFormatter(props) {
        const row = props.cell.getRow();
        const rowData = row.getData();
        const parent = row.getTreeParent();
        const cardData = parent ? parent.getData() : rowData;
        return <>{getEffectiveServiceCompanyName(cardData, rowData)}</>;
    }

    const dateFormatGlob = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFormatGlob = `${dateFormatGlob} HH:mm`;

    const auditColumns = useMemo(
      () =>
        buildScheduledTreeAuditTabulatorColumns({
          includeId: true,
          dateFormat: dateFormatGlob,
          dateTimeFormat: dateTimeFormatGlob,
          getUserColor,
          getUserInitials,
          textHeaderFilter,
        }),
      [dateFormatGlob, dateTimeFormatGlob, getUserColor, getUserInitials, textHeaderFilter]
    );

    const idColumn = useMemo(() => auditColumns.find((c) => c.field === 'id'), [auditColumns]);
    const createdAtColumn = useMemo(() => auditColumns.find((c) => c.field === 'created_at'), [auditColumns]);
    const updatedAtColumn = useMemo(() => auditColumns.find((c) => c.field === 'updated_at'), [auditColumns]);

    const columns = useMemo(() => [
        idColumn,
        { title: 'Stroj', field: 'machine.name', headerFilter:"input", headerFilterFunc: machineHeaderFilter, minWidth: 200, formatter: reactFormatter(<MachineNameTreeFormatter/>) },
        { title: t('MachineList.Column.MachineTypeName'), field: 'machine.machine_type.name', minWidth: 200,
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.All'), valueType: 'string', options: (state.machine_types || []).map(mt => ({ label: mt.name, value: mt.name })) },
        headerFilterFunc: (headerValue, rowValue) => {
          if (!headerValue) return true;
          const selected = new Set(String(headerValue).split(',').map((x) => x.trim()).filter(Boolean));
          return selected.has(String(rowValue ?? ''));
        }
      },
        { title: t('Common.LastPerformed'), field: 'custom_last_execution_date',headerFilter:"input",minWidth: 220,formatter: reactFormatter(<LastExecutionDate/>),headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"last_execution_date"},resizable:false},
        { title: 'Nasled. vykonanie', field: 'custom_next_execution_date',headerFilter:"input",minWidth: 210,formatter: reactFormatter(<NextExecutionDate/>),headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"next_execution_date"},resizable:false},
        { title: t('Common.Status'), field: 'custom_state', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.Status'), options: [{ label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'DEA', value: 'DEA' }] }, headerFilterFunc: stateHeaderFilter, minWidth: 200, formatter: reactFormatter(<StateFormatter/>), resizable: false },
        { title: t('Common.TaskStatus'), field: 'custom_deactivation_date', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.TaskStatus'), options: [{ label: 'Aktívny', value: 'Aktívny' }, { label: t('Status.Deactivated'), value: "Deaktivovaný" }] }, headerFilterFunc: stavUkonuHeaderFilter, minWidth: 180, widthGrow: 1, formatter: reactFormatter(<DeactivationDate/>), resizable: false },
        { title: t('Common.Description'), field: 'description',headerFilter:"input",minWidth: 200,widthGrow:2,resizable:false},
        { title: t('Common.MachinePart'), field: 'machine_part',headerFilter:"input",headerFilterFunc: textHeaderFilter,minWidth: 200,},
        { title: 'Protokol', field: 'protocol',headerFilter:"input",minWidth: 200,formatter: reactFormatter(<Protocol/>)},
        { title: 'Predloha', field: 'scheduled_files', headerFilter:"input", minWidth: 200, formatter: reactFormatter(<Predloha/>)},
        { title: 'Serv. firma', field: 'company.name',headerFilter:"input",headerFilterFunc:serviceCompanyHeaderFilter,minWidth: 200, formatter: reactFormatter(<ServisnaFirmaFormatter/>)},
        { title: 'Druh technika', field: 'custom_lecturer_name',headerFilter:"input", headerFilterFunc: lecturerHeaderFilter,minWidth: 200,formatter: reactFormatter(<LecturerName/>)},
        { title: t('Common.ServiceTechnician'), field: 'custom_contact_name',headerFilter:"input", headerFilterFunc: contactHeaderFilter,minWidth: 210,formatter: reactFormatter(<ContactFormatter/>)},
        createdAtColumn,
        updatedAtColumn,
    ].filter(Boolean), [idColumn, createdAtColumn, updatedAtColumn, state.machine_types, textHeaderFilter]);

    const canSetStandardMask = user?.permissions?.includes('set standard mask');

    const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
      const closeMenu = useCallback(() => {
        setTimeout(() => {
          OverflowMenuProvider.setVisible?.(null);
          setExpandedKeys({});
        }, 0);
      }, []);

      const hasApplicableStandardMask = useMemo(
        () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, mergeMaintenanceMachineDetailColumnVisibilityFromSaved),
        [state.standard_mask_filters]
      );

      const openMaskDialog = useCallback(
        createOpenMaskDialog({
          columnsVisible,
          setColumnsVisible,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY,
          mergeVisibilityFromSaved: mergeMaintenanceMachineDetailColumnVisibilityFromSaved,
          setMaskVisible,
          closeMenu,
        }),
        [columnsVisible, closeMenu]
      );

      const saveUserMaskColumns = useCallback(
        createSaveUserMaskColumns({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY,
          columnsVisible,
          setColumnsVisible,
          setMaskVisible,
          toast,
        }),
        [columnsVisible, getTable, setUserMaskFilter, toast]
      );

      const confirmSaveStandardMask = useCallback(
        createConfirmSaveStandardMask({
          maskPage: MASK_PAGE,
          getTable,
          setStandardMaskFilter,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY,
          toast,
        }),
        [getTable, setStandardMaskFilter, toast]
      );

      const confirmApplyStandardLayoutToUserMask = useCallback(
        createConfirmApplyStandardLayoutToUserMask({
          maskPage: MASK_PAGE,
          state,
          setUserMaskFilter,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY,
          mergeVisibilityFromSaved: mergeMaintenanceMachineDetailColumnVisibilityFromSaved,
          toast,
          closeMenu,
          onAppliedToTable: ({ colsForSave, attributes }) => {
            const table = getTable();
            if (!table) return;
            isRestoringRef.current = true;
            try {
              table.setColumnLayout?.(attributes);
            } catch (_) {}
            setColumnsVisible(colsForSave);
            applyMaintenanceMachineDetailDataColumnVisibility(table, colsForSave);
            setTimeout(() => {
              isRestoringRef.current = false;
              table.redraw?.(true);
              captureHScroll();
              refreshFromStart();
            }, 0);
          },
        }),
        [state, closeMenu, getTable, setUserMaskFilter, toast]
      );

      const setMask = useCallback(
        createMaskSetFieldHandler({
          defaultColumnVisibility: DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY,
          columnsVisible,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyMaintenanceMachineDetailDataColumnVisibility,
          toast,
        }),
        [columnsVisible, getTable, toast]
      );

      const maskSelectAll = useCallback(
        createMaskSelectAllHandler({
          defaultColumnVisibility: DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyMaintenanceMachineDetailDataColumnVisibility,
        }),
        [getTable]
      );

      const maskDeselectAll = useCallback(
        createMaskDeselectAllHandler({
          defaultColumnVisibility: DEFAULT_MAINTENANCE_MACHINE_DETAIL_COLUMN_VISIBILITY,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyMaintenanceMachineDetailDataColumnVisibility,
        }),
        [getTable]
      );
    
      const handleClickOutside = (event) => {
        if (event.target.closest('[data-overflow-trigger]')) return;
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
            OverflowMenuProvider.setVisible?.(null);
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: buildMaintenanceMaskAkcieSubItems({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          cleanSorters,
          captureHScroll,
          refreshFromStart,
          closeMenu,
          openMaskDialog,
          openChosenNotificationPreferences,
          hasApplicableStandardMask,
          confirmApplyStandardLayoutToUserMask,
          itemRenderer,
        }),
      }
    ];

    useEffect(() => {
        if (loadingTypes) {
            getTable()?.alert?.(t('Common.LoadingData'));
        } else {
            getTable()?.clearAlert?.();
        }
    }, [loadingTypes, getTable]);

    /** Jako trng015: keď máme id ale bez plných dát (z minimal listu), donačítame celý záznam pre ľavý panel. Jedno volanie na id vďaka ref. */
    useEffect(() => {
        const id = formMaintenanceType?.id;
        if (id == null) return;
        if (formMaintenanceType?.machine_type != null && formMaintenanceType?.norm !== undefined) return;
        if (loadingMaintenanceTypeIdRef.current === id) return;
        loadingMaintenanceTypeIdRef.current = id;
        setLoadingDetailData(true);
        getRequest(`/api/maintenance_types/${id}`)
            .then((r) => {
                const data = r?.data ?? r;
                if (data) setFormMaintenanceType(data);
            })
            .catch(() => {})
            .finally(() => { loadingMaintenanceTypeIdRef.current = null; setLoadingDetailData(false); });
    }, [formMaintenanceType?.id]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const applyMaintenanceType = (data) => {
            if (!data) return;
            resetDetailUiOnNavigate();
            currentMaintenanceTypeIdRef.current = data.id ?? null;
            setFormMaintenanceType(data);
        };
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.Loading'));
            setVisible?.(true);
            try {
                const q = toParams();
                const url = `/api/maintenance_types/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (
            navigationContext?.filters != null
            || navigationContext?.sorters != null
            || navigationContext?.toolbarSearch != null
        ) {
            const toParams = () => navigationContextToQueryParams(navigationContext);
            return createAsyncNavigateHandlers(
                buildFetchRecord(toParams),
                applyMaintenanceType,
                () => currentMaintenanceTypeIdRef.current ?? formMaintenanceType?.id
            );
        }
        return createAsyncNavigateHandlers(
            buildFetchRecord(),
            applyMaintenanceType,
            () => currentMaintenanceTypeIdRef.current ?? formMaintenanceType?.id
        );
    }, [navigationContext, formMaintenanceType?.id, resetDetailUiOnNavigate, setDialogText, setVisible]);

    if (loadingDetailData) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-177px)] bg-gray-100 gap-4">
                <InfinitySpin width="120" color="#333" />
                <span className="text-gray-700">{t('Common.LoadingData')}</span>
            </div>
        );
    }

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => refetchMaintenanceTypes()} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('MaintenanceMachineDetail.Text.Zoznam_strojov_pl_ukonu'),"MaintenanceMachineDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("MaintenanceMachineDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          {canSetStandardMask ? (
            <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
              <button type="button" title={t('Common.SaveStandardMask')} aria-label={t('Common.SaveStandardMask')} onClick={confirmSaveStandardMask} className="flex items-center justify-center">
                <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
              </button>
            </div>
          ) : null}
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto" minSize={10} size={30}>
        <div className="w-full relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
          <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.ZOZNAM_PODLA_PLANOVANYCH_UKONOV')}</h1>
                <label className="block text-md font-semibold text-gray-800">Por.č.: {formMaintenanceType?.id}</label>
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Name')}</label>
                        <input
                            name='name'
                            type="text"
                            value={formMaintenanceType?.name} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="machine_type_name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.TaskType')}</label>
                        <input
                            name='name'
                            type="text"
                            value={formMaintenanceType?.machine_type?.name} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                            <label className="block text-md font-semibold text-gray-800 mt-2">{t('MachineList.Column.MachineTypeName')}</label>
                            <select name='machine_type_id' disabled value={formMaintenanceType?.machine_type_id}
                                className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400">
                                <option value="">-- Vyber druh stroja --</option>
                                {state.machine_types?.map((mt) => (
                                    <option key={mt.id} value={mt.id}>{mt.name}</option>
                                ))}
                            </select>
                        </div>  
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Norma 
                        </label>
                        <input
                            name='norm'
                            type="text"
                            value={formMaintenanceType?.norm} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                            <label className="block text-md font-semibold text-gray-800 mt-2">{t('Common.IntervalMonths')}</label>
                            <input name='interval_months' type="number" disabled value={formMaintenanceType?.interval_months}
                                className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400" />
                        </div>
                        <div>
                            <label className="block text-md font-semibold text-gray-800 mt-2">{t('Common.ResponsiblePerson')}</label>
                            {formMaintenanceType?.use_central_responsible_person ? (
                                <>
                                    <p className="mt-1 text-sm text-gray-600">{t('Ui.R67.Je_nastavena_centralna_zodpovedna_osoba')}</p>
                                    <select name='responsible_employee_id' disabled value={formMaintenanceType?.responsible_employee_id ?? formMaintenanceType?.responsible?.id ?? ''}
                                        className="block w-full px-4 py-2 mt-2 bg-gray-100 border rounded-md text-gray-700">
                                        <option value="">-- Vyber zamestnanca --</option>
                                        {state.employees?.map((emp) => (
                                            <option key={emp.id} value={emp.id}>{emp.name}</option>
                                        ))}
                                    </select>
                                </>
                            ) : (
                                <select name='responsible_employee_id' disabled value={formMaintenanceType?.responsible_employee_id}
                                    className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400">
                                    <option value="">-- Vyber zamestnanca --</option>
                                    {state.employees?.map((emp) => (
                                        <option key={emp.id} value={emp.id}>{emp.name}</option>
                                    ))}
                                </select>
                            )}
                        </div>
                        {formMaintenanceType?.use_unified_template && (
                            <div>
                                <label className="block text-md font-semibold text-gray-800 mt-2">Predloha</label>
                                <div className="block w-full px-4 py-2 mt-2 bg-gray-100 border rounded-md text-gray-700">
                                    Používa sa jednotná predloha
                                </div>
                            </div>
                        )}
                        {formMaintenanceType?.use_central_service_person && (formMaintenanceType?.central_company_id || formMaintenanceType?.central_company_contact_id) && (
                            <div>
                                <label className="block text-md font-semibold text-gray-800 mt-2">{t('Common.ServiceCompany')}</label>
                                <div className="block w-full px-4 py-2 mt-2 bg-gray-100 border rounded-md text-gray-700">
                                    Je nastavená centrálna servisná firma a servisný technik: {[(formMaintenanceType?.centralCompany?.name || formMaintenanceType?.central_company?.name), formMaintenanceType?.centralCompanyContact?.employee_id != null ? t('Common.InternalEmployeeLower') : t('Common.ServiceCompanyEmployee'), formMaintenanceType?.centralCompanyContact?.employee?.name || formMaintenanceType?.centralCompanyContact?.name || formMaintenanceType?.central_company_contact?.employee?.name || formMaintenanceType?.central_company_contact?.name].filter(Boolean).join(', ')}
                                </div>
                            </div>
                        )}
                        <div>
                            <label className="block text-md font-semibold text-gray-800 mt-2">{t('Common.Description')}</label>
                            <textarea name='description' readOnly value={formMaintenanceType?.description}
                                className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400" />
                        </div>
                         {/*<div>
                        <label
                            htmlFor="images"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Predloha:
                        </label>
                        {images!=='' && images.map((img) => (<table className='w-full border border-separate border-gray-400 rounded-md bg-white mb-4'>
                            <tr>
                                <td className='text-black h-10'><div className='flex flex-row p-2'>
<div onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>
                                        {img.filename.includes(".docx") ?<img src={require('./../../assets/img/word.png')} style={{ height: '65px', width: 'auto'}} alt="Word Logo"/> : <embed src={img.url+'#view=FitH&scrollbar=0'} width='100px' height='65px'></embed>}
                                    </div>
                                    <div className='flex flex-col ml-4'>
                                        <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                        </div>
                                    </div></td>
                            </tr>
                        </table>))}
                        </div>*/}
                    </div>
                </div> 
            </div>
             </SplitterPanel>
             <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full h-full overflow-y-auto" size={30} style={{minHeight: '110px'}}>
             <ReactTabulator
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        tableBuilt: () => {
          tableBuiltRef.current = true;
          const table = getTable();
          if (loadingTypes) table?.alert?.(t('Common.LoadingData'));
          if (!table) return;
          const effective = getEffectiveMask(MASK_PAGE, state);
          if (effective?.type === 'user' && effective.userMask) {
            isRestoringRef.current = true;
            applyUserMaskRowToTabulator(table, effective.userMask, {
              setColumnsVisible,
              clearHeaderFiltersWhenEmpty: true,
              applyColumnVisibilityFn: (tbl, jc, setVis) => {
                const merged = mergeMaintenanceMachineDetailColumnVisibilityFromSaved(jc);
                setVis(merged);
                applyMaintenanceMachineDetailDataColumnVisibility(tbl, merged);
              },
            });
            setTimeout(() => { isRestoringRef.current = false; }, 0);
          } else if (effective?.type === 'standard' && effective.standardMask) {
            isRestoringRef.current = true;
            const m = effective.standardMask;
            const attributes = safeParse(m.attributes, []);
            const jsonColumns = safeParse(m.columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) {
              table.setColumnLayout?.(attributes);
            }
            if (jsonColumns && typeof jsonColumns === 'object') {
              const merged = mergeMaintenanceMachineDetailColumnVisibilityFromSaved(jsonColumns);
              setColumnsVisible(merged);
              applyMaintenanceMachineDetailDataColumnVisibility(table, merged);
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
          }
          refreshFromStart();
        },
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
        headerFilterChanged: () => { if (!isRestoringRef.current) captureHScroll(); refreshFromStart(); },
        sortChanged: () => { if (!isRestoringRef.current) { captureHScroll(); refreshFromStart(); } },
        renderComplete: () => {
          restoreHScroll();
          scheduleAuditTreeExpand();
        },
      }}
      className='h-full w-full'
      options={{
        layout: "fitColumns",
        renderHorizontal: "virtual",
        rowHeight: 42,
        movableColumns: true,
        headerSortTristate: true,
        dataTree: true,
        dataTreeStartExpanded: false,
        dataTreeFilter: false,
        dataTreeElementColumn: "machine.name",
        dataTreeCollapseElement: ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
        dataTreeExpandElement: ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
        dataTreeBranchElement: ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
        ajaxURL: "/api/maintenance_scheduled_records/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingEllipsis'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        filterMode: "remote",
        sortMode: "remote",
        pagination: false,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingEllipsis'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          scheduleAuditTreeExpand();
          return response;
        },
        ajaxError: () => { getTable()?.clearAlert?.(); },
        printAsHtml: true,
        printRowRange: "active",
        printCopyStyle: true,
      printHeader: function () {
            const bodyHtml = ReactDOMServer.renderToStaticMarkup(
            <div className="w-full text-[12px]">
{/* 2. riadok – hlavička v dvoch stĺpcoch */}
                <div className="grid grid-cols-2 gap-6 mb-4">
                    {/* Ľavý stĺpec */}
                    <div className="space-y-3">
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm text-left font-semibold text-gray-800"
                            >{t('Common.Name')}</label>
                            <input
                                name="name"
                                type="text"
                                value={formMaintenanceType?.name}
                                readOnly
                                className="mt-1 block w-full px-3 bg-white border border-gray-300 rounded-md"
                            />
                        </div>

                        <div>
                            <label
                                className="block text-sm text-left font-semibold text-gray-800"
                            >{t('MachineList.Column.MachineTypeName')}</label>
                            <input
                                name="machine_type"
                                type="text"
                                disabled
                                value={formMaintenanceType?.machine_type?.name}
                                className="mt-1 block w-full px-3 bg-white border border-gray-300 rounded-md"
                            />
                        </div>
                    </div>

                    {/* Pravý stĺpec */}
                    <div className="space-y-3">
                        <div>
                            <label className="block text-sm text-left font-semibold text-gray-800">{t('Common.IntervalMonths')}</label>
                            <input
                                name="interval_months"
                                type="number"
                                disabled
                                value={formMaintenanceType?.interval_months}
                                className="mt-1 block w-full px-3 bg-white border border-gray-300 rounded-md"
                            />
                        </div>

                        <div>
                            <label className="block text-sm text-left font-semibold text-gray-800">{t('Common.ResponsiblePerson')}</label>
                            <input
                                name="responsible_employee"
                                type="text"
                                disabled
                                value={formMaintenanceType?.responsible?.name}
                                className="mt-1 block w-full px-3 bg-white border border-gray-300 rounded-md"
                            />
                        </div>
                    </div>
                </div>

                {/* 3. riadok – Popis cez celú šírku */}
                <div className="mt-2">
                    <label className="block text-sm text-left font-semibold text-gray-800">{t('Common.Description')}</label>
                    <textarea
                        name="description"
                        readOnly
                        value={formMaintenanceType?.description}
                        className="mt-1 block w-full px-3 bg-white border border-gray-300 rounded-md min-h-[80px]"
                    />
                </div>
            </div>
        );
            return buildCanonicalPrintHeaderHtml({
                branding: state?.branding,
                productFallbackSrc: defaultProductLogoSrc,
                companySettingsPrint: state?.company_settings_print,
                moduleSettings: state?.module_settings,
                title: t('Print.Title.MaintenanceMachineDetail'),
                printDateLabel: t('Print.DateLabel'),
                bodyHtml,
            });
        },
                printFooter: function () {
                    return buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print });
                }}}/>
    </SplitterPanel>
    </Splitter> 
            <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
          <p className="text-sm text-gray-600 mb-2">{t('MaintenanceTemplateList.MaskHelp')}</p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
            <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
          </div>
        {columns.map((item) => {
          if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                    return <div 
                        key={item.field} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 
                         <MaintenanceMaskDialogCheckbox field={item.field} inputId={`mmd-mask-${item.field}`} title={item.title || item.field} columnsVisible={columnsVisible} onChange={setMask} /><label htmlFor={`mmd-mask-${item.field}`} className={`ml-2 ${item.field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>
                    </div> 
                })} 
            <button type="button" onClick={saveUserMaskColumns} className='m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700'>{t('Common.SaveUpper')}</button>
        </div>
      </Dialog>
</div>
            </> 
            );
} 
